import { writable, derived } from 'svelte/store';

export enum ConnectionStatus {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  RECONNECTING = 'reconnecting',
  ERROR = 'error',
}

interface ConnectionState {
  status: ConnectionStatus;
  error: string | null;
}

export const connectionStore = writable<ConnectionState>({
  status: ConnectionStatus.DISCONNECTED,
  error: null,
});

export const isConnected = derived(
  connectionStore,
  ($connection) => $connection.status === ConnectionStatus.CONNECTED
);

export function setConnectionStatus(status: ConnectionStatus, error: string | null = null): void {
  connectionStore.set({ status, error });
}
